import { Value } from "@convertkit/slate"

export const createValue = (content, { type }) =>
  Value.fromJSON({
    document: {
      nodes: [
        {
          object: "block",
          type: type,
          nodes: [
            {
              object: "text",
              leaves: [
                {
                  text: content,
                  marks: []
                }
              ]
            }
          ]
        }
      ]
    }
  })
